// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5545": "20927b2f494d","6863": "454c9f289029","8696": "bbb68422bd59","8795": "771c29ae18b2",}[chunkId] + ".css"
}